import script from "./model.vue?vue&type=script&setup=true&lang=js"
export * from "./model.vue?vue&type=script&setup=true&lang=js"

import "./model.vue?vue&type=style&index=0&id=0c610c5e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c610c5e"]])

export default __exports__